// extracted by mini-css-extract-plugin
export default {"search":"risks_search__+u0kw","fieldRow":"risks_fieldRow__3dikX","field":"risks_field__Qe7ZT","count":"risks_count__EFXq-","list":"risks_list__N1Nji"};